module.exports = __webpack_public_path__ + "static/z_tall_12_commandments-bff2e6ed7c6af1ca4af19ec692623ac9.jpg";